import { render } from "./OneProduct.vue?vue&type=template&id=1565ea82&scoped=true"
import script from "./OneProduct.vue?vue&type=script&lang=js"
export * from "./OneProduct.vue?vue&type=script&lang=js"

import "./OneProduct.vue?vue&type=style&index=0&id=1565ea82&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1565ea82"]])

export default __exports__